<template>
  <div id="app">
    <div v-if="show" class="wechatBg" />
    <a-Layout v-if="!show">
      <a-layout-header :class="{ showBg: showBg, whiteBg: change }">
        <Head />
      </a-layout-header>

      <a-layout-content>
        <div class="lambbody">
          <router-view v-if="isRouterAlive" />
        </div>
      </a-layout-content>
      <a-layout-footer>
        <Foot />
      </a-layout-footer>
    </a-Layout>
  </div>
</template>
<script>
import Foot from '@/Layout/Foot.vue';
import Head from '@/Layout/Head.vue';
import { mapState } from 'vuex';
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      change: false,
      showBg: false,
      isRouterAlive: true
    };
  },
  components: {
    Foot,
    Head,
  },
  watch: {
    $route(to) {
      this.change = to.meta.changeNav;
    },
  },
  computed: {
    ...mapState(['show']),
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      if (scrollTop > 64) {
        this.showBg = true;
      } else {
        this.showBg = false;
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        const context = this,
          args = arguments;
        const later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
  },
  mounted() {
    window.addEventListener('scroll', this.debounce(this.handleScroll, 30, false));
  },
  destroyed() {
    window.removeEventListener('scroll', this.debounce(this.handleScroll, 30, false));
  },
};
</script>

<style lang="less">
// .lambbody{
//   z-index: 1;
// }
#app {
  overflow-x: hidden;
}
.wechatBg {
  max-width: 100vw;
  height: 100vh;
  background-image: url('./assets/open.png');
  background-color: rgba(0, 0, 0, 0.5);
  background-size: 100% 100%;
}
.showBg {
  background: #4953e8 !important;
}
.whiteBg {
  background: #fff !important;
}
</style>
